
import React, { Component } from 'react'
import { FormButton, FormButtonContent } from '@myxplor/forms'
import { ContentToggleIcon } from '@myxplor/icons'
import './show-hide.css'

class ShowHide extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      open: false
    }
  }

  toggle() {
    this.setState({
      open: !this.state.open
    })
  }

  render() {
    const { open } = this.state

    return (
      <div className="showHide--wrapper">
        <FormButton center className="showHide--toggle" onClick={this.toggle}>
          <ContentToggleIcon left open={open} />
          <FormButtonContent>
            {`${open ? 'Hide' : 'View'} ${this.props.label || 'more details'}`}
          </FormButtonContent>
        </FormButton>

        {
          open ?
            <div className="showHide--content">
              {this.props.children}
            </div>
            : null
        }
      </div>
    )
  }
}

export default ShowHide


// WEBPACK FOOTER //
// ./src/ui/record-display/views/show-hide.jsx